import { baseInstance } from './base-instance';
import { config } from '../env-helpers';
import axios from 'axios';
import { setupInterceptors } from './interceptors';

export const AxiosMediaUploadInstance = axios.create({
  ...baseInstance.defaults,
  baseURL: config.MEDIA_UPLOAD_ENDPOINT,
  responseType: 'json',
});

setupInterceptors(AxiosMediaUploadInstance);
